import { PURCHASE_ORDER_LIST_GET_DONE } from '../../action/purchaseOrder';

const initState = {
	data: [],
	error: null,
	status: null,
	currentlogedInuser: null,
};

export const purchaseOrderReducer = (state = initState, action) => {
	switch (action.type) {
		case PURCHASE_ORDER_LIST_GET_DONE:
			return {
				...state,
				data: {
					data: action?.payload?.data?.data,
					status: action?.payload?.data?.status,
					error: null,
				},
			};
		default:
			return state;
	}
};
